export default "__VITE_ASSET__BLs0bajy__"